import React, { FC, ReactElement, ReactNode } from 'react';

import { ISkeletonProps } from '@ui/atoms/Skeleton';

interface ILoadingWrapperProps {
	loading: boolean;
	children: ReactNode | false;
	skeleton?: ReactElement<ISkeletonProps>;
}

const LoadingWrapper: FC<ILoadingWrapperProps> = ({ children, skeleton = <></>, loading }) => {
	return loading ? skeleton : children || <></>;
};

export default LoadingWrapper;
